import { Text, Caution, TagGroup, Truncate } from '@cad-arc';
import { AttributeOption } from '@mark43/cad-api';
import { globalAttributes } from '../../../../common/global-attributes';
import { BaseQueueCell } from '../../../../queues/components/base-queue-cell';
import { BoloQueueRowData } from '../../../../socket/stream-types';
import { Tooltip } from '~/common/components/tooltip';

const boloLabelPriorityToCautionPriority = {
    [globalAttributes.boloLabelPriorityGlobal.PRIORITY_1]: 1,
    [globalAttributes.boloLabelPriorityGlobal.PRIORITY_2]: 2,
    [globalAttributes.boloLabelPriorityGlobal.PRIORITY_3]: 3,
    [globalAttributes.boloLabelPriorityGlobal.PRIORITY_4]: 4,
} as const;

type BoloLabelPriorityGlobal = keyof typeof boloLabelPriorityToCautionPriority;

function getPriority(
    boloLabelPriorityGlobalAttrId?: BoloLabelPriorityGlobal
): 1 | 2 | 3 | 4 | undefined {
    if (boloLabelPriorityGlobalAttrId === undefined) {
        return undefined;
    }
    return boloLabelPriorityToCautionPriority[boloLabelPriorityGlobalAttrId];
}

export const BoloLabelPill = ({ label }: { label: AttributeOption }) => {
    return (
        <Caution
            key={label.value}
            priority={getPriority(label.parentAttributeId as BoloLabelPriorityGlobal)}
            className="bolo-label-pill"
        >
            {label.label}
        </Caution>
    );
};

export function TruncatedBoloLabels({ labels }: { labels: AttributeOption[] }) {
    return (
        <Truncate
            renderCounter={(truncatedCount) => {
                return (
                    <Tooltip
                        overlay={
                            <TagGroup>
                                {labels?.slice(-1 * truncatedCount).map((label) => {
                                    return <BoloLabelPill key={label.value} label={label} />;
                                })}
                            </TagGroup>
                        }
                    >
                        <Text fontSize="sm" color="secondary" decoration="underline">
                            + {truncatedCount}
                        </Text>
                    </Tooltip>
                );
            }}
        >
            {labels.map((label) => {
                return <BoloLabelPill key={label.value} label={label} />;
            })}
        </Truncate>
    );
}

export function BoloLabelsCell({ data }: { data: BoloQueueRowData }) {
    return (
        <BaseQueueCell>
            <TruncatedBoloLabels labels={data.labels!} />
        </BaseQueueCell>
    );
}
